import React from 'react';
import { Container } from 'semantic-ui-react';

import Categories from './Categories';
import EpisodeSpotlight from './EpisodeSpotlight';
import MoreLinks from './MoreLinks';

const Home = ({ episodes, loading }) => (
  <Container>
    <Categories />
    <EpisodeSpotlight episodes={episodes} loading={loading} />
    <MoreLinks />
  </Container>
);

export default Home;
